import { SlideTemplate } from '@dopomogai/types';

export const slideTemplates: SlideTemplate[] = [
  {
    type: 'title',
    title: 'Title Slide',
    description: 'A bold, centered slide perfect for starting your presentation.',
    icon: 'Type',
    defaultContent: `({ data, theme }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', textAlign: 'center', padding: '2rem' }}>
      <h1 style={{ fontSize: theme.fontSizes.h1, color: theme.colors.primary, textShadow: '2px 2px 4px rgba(0,0,0,0.2)' }}>
        {data.title || 'Your Title Here'}
      </h1>
      <p style={{ fontSize: theme.fontSizes.h3, color: theme.colors.primary, opacity: 0.9, marginTop: '40px' }}>
        A compelling subtitle or brief description
      </p>
    </div>
  );
}`
  },
  {
    type: 'content',
    title: 'List Slide',
    description: 'A heading with a list for key points.',
    icon: 'FileText',
    defaultContent: `({ data, theme }) => {
  return (
    <div style={{ width: '100%', height: '100%', padding: '3rem', backgroundColor: theme.colors.quaternary, color: theme.colors.secondary }}>
      <h2 style={{ marginBottom: '2rem', fontSize: theme.fontSizes.h2 }}>
        {data.title || 'Key Takeaways'}
      </h2>
      <ul style={{ fontSize: theme.fontSizes.h4, listStylePosition: 'inside', paddingLeft: '1rem' }}>
        <li style={{ marginBottom: '1rem' }}>First impactful point.</li>
        <li style={{ marginBottom: '1rem' }}>Second crucial detail.</li>
        <li style={{ marginBottom: '1rem' }}>Third supporting argument.</li>
      </ul>
    </div>
  );
}`
  },
  {
    type: 'code',
    title: 'Code Slide',
    description: 'Display a code snippet with syntax highlighting.',
    icon: 'Code',
    defaultContent: `({ data, theme }) => {
  return (
    <div style={{ width: '100%', height: '100%', padding: '2rem', backgroundColor: '#0f172a' }}>
      <h3 style={{ color: 'white', marginBottom: '1.5rem', fontSize: theme.fontSizes.h3 }}>
        {data.title || 'Code Example'}
      </h3>
      <pre style={{
        backgroundColor: '#1e293b',
        color: '#e2e8f0',
        padding: '1.5rem',
        borderRadius: '8px',
        fontSize: '1.25rem',
        fontFamily: theme.fonts.monospace,
        overflowX: 'auto'
      }}>
        <code>{\`function example(name) {
  return \\\`Hello, \${name}\\\`;
}\`}</code>
      </pre>
    </div>
  );
}`
  },
  {
    type: 'quote',
    title: 'Quote Slide',
    description: 'Highlight an inspirational or important quote.',
    icon: 'Quote',
    defaultContent: `({ data, theme }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', padding: '2rem' }}>
      <blockquote style={{ borderLeft: '5px solid ' + theme.colors.tertiary, paddingLeft: '2rem' }}>
        <p style={{ fontSize: theme.fontSizes.h2, color: theme.colors.primary, fontStyle: 'italic' }}>
          "The best way to predict the future is to invent it."
        </p>
        <cite style={{ display: 'block', fontSize: theme.fontSizes.h4, color: theme.colors.primary, opacity: 0.7, marginTop: '2rem', textAlign: 'right' }}>
          — A Wise Person
        </cite>
      </blockquote>
    </div>
  );
}`
  },
  {
    type: 'image',
    title: 'Image Slide',
    description: 'A full-bleed image with overlay text for impact.',
    icon: 'Image',
    defaultContent: `({ data, theme }) => {
  return (
    <div style={{
      width: '100%', height: '100%',
      backgroundImage: 'url(https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?w=1600)',
      backgroundSize: 'cover', backgroundPosition: 'center',
      display: 'flex', alignItems: 'center', justifyContent: 'center'
    }}>
      <div style={{
        width: '100%', height: '100%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)', textAlign: 'center'
      }}>
        <h1 style={{ fontSize: theme.fontSizes.h1, color: 'white', textShadow: '2px 2px 8px rgba(0,0,0,0.7)' }}>
          {data.title || 'Overlay Title'}
        </h1>
      </div>
    </div>
  );
}`
  },
  {
    type: 'fact',
    title: 'Big Fact Slide',
    description: 'Emphasize a key statistic or number.',
    icon: 'Zap',
    defaultContent: `({ data, theme }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%', textAlign: 'center' }}>
      <h1 style={{ fontSize: '10rem', fontWeight: 900, color: theme.colors.primary, lineHeight: 1 }}>
        95%
      </h1>
      <p style={{ fontSize: theme.fontSizes.h3, color: theme.colors.primary, opacity: 0.8, marginTop: '1rem' }}>
        increase in productivity
      </p>
    </div>
  );
}`
  },
];